import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  gap: 0.5rem;
  justify-content: center;

  input {
    font-size: 2rem;
    text-align: center;
    width: 60px !important;
    height: 60px !important;
    border: 1px solid ${({ theme }) => theme.colors.secondary};
    color: ${({ theme }) => theme.colors.secondary};
    border-radius: 15px;
    text-transform: uppercase;
    outline: none;
  }

  input:not(:read-only):focus {
    border: 1px solid ${({ theme }) => theme.colors.secondary};
  }

  input:last-child {
    margin-right: 0;
  }

  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  input[type='number'] {
    -moz-appearance: textfield;
  }

  .with-error {
    border: 1px solid red;
  }

  @media (max-width: 660px) {
    input {
      width: 50px !important;
      height: 50px !important;
    }
  }

  @media (max-width: 360px) {
    input {
      width: 40px !important;
      height: 40px !important;
    }
  }
`;
